import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__collections } from '../STATE__collections';

export const remote_collection_create = createAsyncThunkSafe<string | DTO_RESPONSE__error, string>(
  ENUM__network_event_client_to_server.COLLECTION_CREATE,
  async (workspace_id): Promise<string | DTO_RESPONSE__error> => {
    return await send_to_server(ENUM__network_event_client_to_server.COLLECTION_CREATE, workspace_id);
  },
);

export function init_remote_collection_create(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(remote_collection_create.pending, (state, action) => {})
    .addCase(remote_collection_create.rejected, (state, action) => {})
    .addCase(remote_collection_create.fulfilled, (state, action: PayloadAction<string | DTO_RESPONSE__error>) => {});
}
